const paises = [
	{
		nombre: 'Argentina',
		ind: '+54 ',
	},
	{
		nombre: 'Bolivia',
		ind: '+591 ',
	},
	{
		nombre: 'Chile',
		ind: '+56 ',
	},
	{
		nombre: 'Colombia',
		ind: '+57 ',
	},
	{
		nombre: 'Costa Rica',
		ind: '+506 ',
	},
	{
		nombre: 'Cuba',
		ind: '+53 ',
	},
	{
		nombre: 'Ecuador',
		ind: '+593 ',
	},
	{
		nombre: 'El Salvador',
		ind: '+503 ',
	},
	{
		nombre: 'España',
		ind: '+34 ',
	},
	{
		nombre: 'Estados Unidos',
		ind: '+1 ',
	},
	{
		nombre: 'Guatemala',
		ind: '+502 ',
	},
	{
		nombre: 'Honduras',
		ind: '+504 ',
	},
	{
		nombre: 'México',
		ind: '+52 ',
	},
	{
		nombre: 'Nicaragua',
		ind: '+505 ',
	},
	{
		nombre: 'Panamá',
		ind: '+507 ',
	},
	{
		nombre: 'Paraguay',
		ind: '+595 ',
	},
	{
		nombre: 'Perú',
		ind: '+51 ',
	},
	{
		nombre: 'Puerto Rico',
		ind: '+1787 ',
	},
	{
		nombre: 'República Dominicana',
		ind: '+1809 ',
	},
	{
		nombre: 'Uruguay',
		ind: '+598 ',
	},
	{
		nombre: 'Venezuela',
		ind: '+58 ',
	},
];

export const cursos = [
	{
		nombre: 'Aprender 3D desde cero',
	},
	{
		nombre: 'Modelos para impresión 3D',
	},
	{
		nombre: 'Personajes para videojuegos',
	},
	{
		nombre: 'Personajes para animación',
	},
	{
		nombre: 'Escultura Realista',
	},
	{
		nombre: 'Rigging',
	},
	{
		nombre: 'Animación',
	},
	{
		nombre: 'Otros...',
	},
];

export default paises;
